<form [formGroup]="form">
  <div class="plan-wrapper">
    <h1>Select your Delm8 plan</h1>
    <p class="info-text">Cancel anytime no minimum contract</p>
    <div class="plan-list" *ngIf="planList.length">
      <div class="plan-block" *ngFor="let plan of planList">
        <input
          type="radio"
          name="planId"
          formControlName="planId"
          id="monthly"
          value="{{ plan.id }}"
        />
        <div class="plan-inner">
          <div class="d-flex justify-content-between">
            <h2>DELM8 {{ plan.duration | uppercase }}</h2>
            <mat-chip
              highlighted
              *ngIf="plan.duration === 'annual'"
              color="primary"
            >
              Most Popular
            </mat-chip>
          </div>
          <p>
            <strong>£{{ plan.per_driver_price }}</strong>/ Per user per
            {{ plan.duration === "monthly" ? "month" : "year" }}
          </p>
          <ul>
            <li *ngIf="plan.duration === 'monthly'">
              <mat-icon>check_circle</mat-icon> Rolling Monthly
            </li>
            <li *ngIf="plan.duration === 'annual'">
              <mat-icon>check_circle</mat-icon> 2 Months free
            </li>
            <li><mat-icon>check_circle</mat-icon> Cancel Anytime</li>
            <li>
              <mat-icon>check_circle</mat-icon> Add or remove drivers online
            </li>
            <li>
              <mat-icon>check_circle</mat-icon> Enable and disable drivers with
              ease
            </li>
          </ul>
        </div>
      </div>
    </div>
    <button
      mat-flat-button
      class="primary-btn"
      matStepperNext
      disabled="{{ !form.valid }}"
    >
      Next
    </button>
    <div class="d-flex justify-content-center link-block">
      Already have an account?
      <a href="/login" class="link-primary">Login</a>
    </div>
  </div>
</form>
